export default
{
    name: 'app-transition',

    props:
    {
        isActive: { type: Boolean, default: false }
    },

    data()
    {
        return {
            color: 'black'
        }
    },

    created()
    {
        this.eventHub.$on('app-transition:change-color', this._changeColor)
    },

    destroyed()
    {
        this.eventHub.$off('app-transition:change-color', this._changeColor)
    },

    methods:
    {
        _changeColor(color = 'white')
        {
            this.color = color
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-transition/script.js